<template>
  <v-container
    ref="container"
    style="padding:0"
    class="fill-height page"
    fluid
  >
    <div class="overlay" />

    <v-row
      class="f-flex"
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="4"
      >
        <v-card class="elevation-12">
          <v-toolbar
            color="primary"
            dark
            flat
          >
            <v-toolbar-title>Compte crée avec succès !</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            Votre demande de création de compte a été créé avec succès. Un email vient de vous être envoyé pour confirmer votre adresse. Cliquez sur le lien de confirmation et vous pourrez vous connecter avec ainsi que le mot de passe saisi pendant l'inscription pour accéder à la nouvelle plateforme Artifex du Calame d'Or.
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
            />
            <v-spacer />
            <v-btn
              color="primary"
              dark
              :loading="inProgress"
              @click="$router.push('/account/login')"
            >
              Me connecter
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    data: () => ({

    }),
    mounted () {
      this.$auth.logout()
      setTimeout(() => {
        this.$router.push('/account/login')
      }, 5000)
    },
  }
</script>

<style scoped>
.page {
  padding: 0!important;
  position: relative;
  background-position: center;
  background-size: cover;
  background-image: url('https://imaginary.service.codeisalie.fr/resize?height=80&url=https://storage.service.lecalamedor.fr/strapi/DSC_0173_5f06dace78.JPG');
}

.overlay {
  position: absolute;
  background: rgba(0, 0, 0, 0.7);
  height:100%;
  width:100%
}
</style>
